module.exports = __webpack_public_path__ + "img/button-text-block-quote.b53cc06.svg";